import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, SxProps, Theme } from '@mui/material';

/**
 * A large, pill-shaped "clear" control for chart / tour selections, so resetting the view is an obvious target
 * rather than a small text link. `detail` (e.g. the selected tour) is shown after the action and may truncate.
 */
export default function ClearSelectionPill({
  action = 'Clear Selection',
  detail,
  onClick,
  sx,
}: {
  action?: string;
  detail?: string | null;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  sx?: SxProps<Theme>;
}) {
  return (
    <Button
      variant="outlined"
      color="primary"
      startIcon={<CloseIcon />}
      onClick={onClick}
      title={detail ? `${action}: ${detail}` : action}
      sx={[
        {
          borderRadius: 999,
          borderWidth: 2,
          minHeight: 40,
          px: 2,
          maxWidth: '100%',
          textTransform: 'none',
          fontWeight: 600,
          fontSize: '0.9rem',
          bgcolor: 'background.paper',
          '&:hover': { borderWidth: 2 },
          '& .MuiButton-startIcon': { flexShrink: 0 },
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      <Box component="span" sx={{ whiteSpace: 'nowrap', flexShrink: 0 }}>
        {action}
      </Box>
      {detail && (
        <Box
          component="span"
          sx={{
            ml: 0.75,
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontWeight: 400,
            color: 'text.secondary',
          }}
        >
          · {detail}
        </Box>
      )}
    </Button>
  );
}
